const BasicCommander = () => {
  return <mesh position={[0, 1,0]}>
  <capsuleGeometry args={[0.75, 0.75, 4, 8]} />
  <meshStandardMaterial color={0x330000} />
</mesh>
}

export default BasicCommander
